/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomAddActionCard from '../../../../common/components/CustomAddActionCard/CustomAddActionCard';
import _ from 'lodash';
import ActiveLoansTile from '../../../../common/components/ActiveLoansTile/ActiveLoansTile';
import LoanHistoryViewModalController from '../../../../common/Modals/Loans/LoanHistoryViewModal/LoanHistoryViewModalController';
import { Grid, Typography } from '@mui/material';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import { fonts, themes } from '../../../../common/themes/themes';
import { getAmount } from '../../../../common/configs/utils';
import Loader from '../../../../common/Lottifiers/Loader/Loader';

interface propsType {
  loansData: any;
  currency: any;
  isLoading?: boolean;
  trans?: any;
}
const LoansFinishedPresenter: React.FC<propsType> = ({
  loansData,
  currency,
  isLoading,
  trans,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [loanViewData, setLoanViewData] = useState([]);
const status = (data: any) => {
  const hasOngoing = data?.emi?.some((e: any) => e.status === 3);

  return hasOngoing ? 4 : data?.status;
};

  return (
    <>
      <CustomAddActionCard
        card_height="330px"
        card_subtitle={`${trans('Total')}: ${loansData.length}`}
        card_title={trans('Recurring Payment History')}
        isAddButton={false}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {loansData.length > 0 ? (
              _.map(loansData, (loan) => {
                return (
                  <ActiveLoansTile
                    loanName={loan?.type?.name}
                    duration={loan?.duration}
                    completedPaidAmount={currency + ' ' + getAmount(loan?.completedPaidAmount)}
                    pendingAmount={currency + ' ' + getAmount(loan?.pendingAmount)}
                    submitted={loan?.created_at}
                    amount={
                      loan?.amount
                        ? currency + ' ' + getAmount(loan?.amount)
                        : '--'
                    }
                    status={status(loan)}
                    isFinished={true}
                    onClickView={() => {
                      setOpenModal(true);
                      setLoanViewData(loan);
                    }}
                  />
                );
              })
            ) : (
              <Grid container style={{ marginTop: '2em' }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Applied')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                    marginBottom: '2em',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any Recurring Payment History')}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </div>
        )}
      </CustomAddActionCard>

      {/* Loan History View Modal */}
      {openModal && (
        <LoanHistoryViewModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          loanViewModalData={loanViewData}
        />
      )}
    </>
  );
};

export default LoansFinishedPresenter;
